import { render, staticRenderFns } from "./detail_config_dataset_group_list_item_add.vue?vue&type=template&id=3ed28630&scoped=true"
import script from "./detail_config_dataset_group_list_item_add.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_group_list_item_add.vue?vue&type=script&lang=js"
import style0 from "./detail_config_dataset_group_list_item_add.vue?vue&type=style&index=0&id=3ed28630&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed28630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed28630')) {
      api.createRecord('3ed28630', component.options)
    } else {
      api.reload('3ed28630', component.options)
    }
    module.hot.accept("./detail_config_dataset_group_list_item_add.vue?vue&type=template&id=3ed28630&scoped=true", function () {
      api.rerender('3ed28630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_dataset_group_list_item_add.vue"
export default component.exports